# Connections

This is where you can set the Omni Server for this player.

Note: Omni is in active development and may not be available on this version of CanvasPro.

## Omni Connections

### Omni IP Address

The public facing IP address of the Omni Server, this needs to be reachable from the player.

### Username

The username to authenticate with the Omni Server. (Set on the Omni Server)

### Password

The password to authenticate with the Omni Server. (Set on the Omni Server)
